import { baseMSWFollowUp } from '../validations/msw-follow-up/v1';
const shape = baseMSWFollowUp.shape;
export const problemField = [{ key: 'problem', field: shape.problem }];
export const progressPlanFields = [
    { key: 'mswProgress', field: shape.mswProgress },
    { key: 'followUpPlan', field: shape.followUpPlan },
];
